import styled from 'styled-components';
import PropTypes from 'prop-types';
import H3 from '@base/H3/H3';
import { Fonts } from '../../../styleConstants';

const SectionDescription = styled(H3)`
  font-weight: ${Fonts.REGULAR};
  color: #7b8ab5;
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  font-size: ${({ $size }) => $size};
`;

SectionDescription.propTypes = {
  $size: PropTypes.string
};

SectionDescription.defaultProps = {
  $size: Fonts.H3
};

export default SectionDescription;
